<div 
  class="progressbar"
  [ngClass]="error ? 'fail' : ''"
  style="--progress: {{ value }}"
></div>
